import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Alert } from 'antd';
import { AppContext, IAppContext } from 'appState/appContext';
import { IAppError } from 'types';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './ErrorHandler.module.scss';

const ErrorHandler: React.FC = () => {
	const { appErrors, removeAppError } = useContext<IAppContext>(AppContext);

	const handleReload = ({ id, retryHandler }: IAppError) => {
		retryHandler && retryHandler();
		removeAppError(id);
	};

	return (
		<div className={style.container} data-test="ErrorHandler">
			{appErrors.map((el) => {
				const title = (
					<Text translationNameSpace="error" translationKey="errorHandlerAlert" size="l" weight="bold" />
				);

				const [errorType, errorDescription] = el.message.split(/\n/);
				const description = (
					<>
						<Text
							className={style.alertDescription}
							translationNameSpace="error"
							translationKey={errorType}
						/>
						{errorDescription && (
							<Text
								className={style.alertDescription}
								translationNameSpace="error"
								translationKey={errorDescription}
							/>
						)}
					</>
				);

				return (
					<Alert
						key={el.id}
						className={style.alert}
						message={title}
						description={description}
						onClose={() => removeAppError(el.id)}
						type="error"
						showIcon={true}
						closable={true}
						closeIcon={
							<svg className={style.closeIcon}>
								<use xlinkHref={`${breadcrumbs}#crossMark`} />
							</svg>
						}
						icon={
							<svg className={style.errorIcon}>
								<use xlinkHref={`${breadcrumbs}#errorHandlerIcon`} />
							</svg>
						}
						action={
							el.retryHandler && (
								<div className={style.reloadBtn} onClick={() => handleReload(el)}>
									<svg>
										<use xlinkHref={`${breadcrumbs}#reload`} />
									</svg>
									<Text
										translationNameSpace="error"
										translationKey="tryAgainButton"
										asFragment={true}
									/>
								</div>
							)
						}
					/>
				);
			})}
		</div>
	);
};

export default ErrorHandler;
